import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SourceType } from "@bpm/models";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class SourceTypeService {
  //EndPoint para controlador de este objeto en backend
  private sourceTypesApiEndPoint = `${environment.bpmApiUrl}/api/source-types`;

  constructor(private _http: HttpClient) {}

  /**
   * Devuelve todos los tipos de fuente disponibles en la db
   * @returns {Observable<SourceType[]>} - Listado de tipos de fuente disponibles
   */
  getAllSourceTypes(): Observable<SourceType[]> {
    return this._http.get<SourceType[]>(this.sourceTypesApiEndPoint);
  }
}
